export var ICON_ACTIVE_COLORS = {
  heart: '#e03d43'
};
export var LIKE_ANNOTATION = 'like';